<ng-container *transloco="let t; read: 'ivr-option-editor'">
  <p-toast position="bottom-center"></p-toast>
  <ng-template #objEditor>
    <p-messages severity="error">
      <ng-template pTemplate>
        <div class="ml-2">
          <strong>{{ t('safetyNoteTitle') }}</strong>
          <br />
          {{ t('safetyNoteBody') }}
        </div>
      </ng-template>
    </p-messages>

    <div class="ivr-option-editor">
      <form class="ivr-option-editor__form" [formGroup]="form">
        <!-- Option Name -->
        <div class="ivr-option-editor__field">
          <span class="p-float-label w-full">
            <input class="w-full" id="ivrOptionDisplayName" pInputText type="text" [formControl]="displayName" />
            <label for="ivrOptionDisplayName">{{ t('optionNameLabel') }}</label>
          </span>
          <app-form-field-help [control]="displayName">
            <ng-container form-field-help-errors>
              <ng-container *ngIf="displayName.errors?.required">{{ t('optionNameRequired') }}</ng-container>
              <ng-container *ngIf="displayName.errors?.maxlength">{{ t('optionNameMaxLength') }}</ng-container>
            </ng-container>
          </app-form-field-help>
        </div>

        <!-- Description -->
        <div class="ivr-option-editor__field">
          <span class="p-float-label w-full">
            <textarea
              class="w-full"
              id="ivrOptionDescription"
              pInputTextarea
              rows="2"
              [formControl]="description"
            ></textarea>
            <label for="ivrOptionDescription">{{ t('descriptionLabel') }}</label>
          </span>
          <app-form-field-help [control]="description">
            <ng-container form-field-help-errors>
              <ng-container *ngIf="description.errors?.required">{{ t('descriptionRequired') }}</ng-container>
              <ng-container *ngIf="description.errors?.maxlength">{{ t('descriptionMaxLength') }}</ng-container>
            </ng-container>
          </app-form-field-help>
        </div>

        <!-- Keypresses -->
        <div class="ivr-option-editor__field">
          <label class="ivr-option-editor__label" for="ivrOptionKeyPresses">{{ t('keyPressesLabel') }}</label>
          <p-chips
            class="w-full"
            id="ivrOptionKeyPresses"
            [addOnBlur]="true"
            [addOnTab]="true"
            [allowDuplicate]="false"
            [formControl]="keyPresses"
            [inputStyle]="{ width: '100%' }"
            [style]="{ display: 'block', width: '100%', maxWidth: '100%' }"
          ></p-chips>
          <app-form-field-help [control]="keyPresses">
            <ng-container form-field-help-errors>
              <ng-container *ngIf="keyPresses.errors?.required">{{ t('keyPressesRequired') }}</ng-container>
              <ng-container *ngIf="keyPresses.errors?.invalidItems">{{ t('keyPressesInvalidItems') }}</ng-container>
            </ng-container>
            <ng-container form-field-help-hint>{{ t('keyPressesHint') }}</ng-container>
          </app-form-field-help>
        </div>

        <!-- Phrases -->
        <div class="ivr-option-editor__field">
          <label class="ivr-option-editor__label" for="ivrOptionPhrases">{{ t('phrasesLabel') }}</label>
          <p-chips
            class="w-full"
            id="ivrOptionPhrases"
            [addOnBlur]="true"
            [addOnTab]="true"
            [allowDuplicate]="false"
            [formControl]="phrases"
            [inputStyle]="{ width: '100%' }"
            [style]="{ display: 'block', width: '100%', maxWidth: '100%' }"
          ></p-chips>
          <app-form-field-help [control]="phrases">
            <ng-container form-field-help-errors>
              <ng-container *ngIf="phrases.errors">{{ t('phrasesMaxLength') }}</ng-container>
            </ng-container>
            <ng-container form-field-help-hint>{{ t('phrasesHint') }}</ng-container>
          </app-form-field-help>
        </div>

        <!-- Commands -->
        <div class="ivr-option-editor__field">
          <app-service-operation-editor
            [excludedCommands]="excludedCommands"
            [formControl]="commands"
            [maxCommands]="5"
            [required]="true"
          ></app-service-operation-editor>
        </div>
      </form>
    </div>
  </ng-template>

  <app-settings
    [doUpload]="doUpload"
    [editorTemplate]="objEditor"
    [isValid]="isValid"
    [refreshData]="refreshData"
    [resetForm]="resetForm"
  >
  </app-settings>
</ng-container>
